export default {
  organization: 'Organization',

  // Details
  organizationDetails: 'Organization Details',
  organizationDetailsDescription: 'Manage your organization name.',
  name: 'Name',
  organizationNamePlaceholder: 'Organization name',
  domain: 'Domain',
  domainPlaceholder: 'example.com',
  organizationNameRequired: 'Organization name is required',
  organizationUpdated: 'Organization updated',
  failedToUpdateOrganization: 'Failed to update organization',

  // Domain verification
  organizationDomain: 'Organization domain',
  organizationDomainDescription:
    'Verify your corporate domain to automatically approve matching organization invitations.',
  loadingDomain: 'Loading domain...',
  addDomain: 'Add domain',
  editDomain: 'Edit domain',
  saveDomain: 'Save domain',
  domainNotConfigured: 'No corporate domain has been configured.',
  domainPending: 'Pending verification',
  domainVerified: 'Verified',
  domainUnverified: 'Not verified',
  addDnsRecord: 'Add this DNS record',
  dnsPropagationDescription:
    'DNS updates can take up to 48 hours. Keep this record in place after verification.',
  dnsRecordNotFound: 'DNS record not found',
  dnsRecordNotFoundDescription:
    'Check the TXT value at the root of your domain, then try again after DNS has propagated.',
  dnsRecordDetails: 'DNS record',
  dnsRecordType: 'Type',
  dnsRecordValue: 'Value',
  verifyDomain: 'Verify domain',
  checkDomainAgain: 'Check again',
  domainChallengeCreated: 'DNS verification instructions are ready',
  domainChallengeFailed: 'Could not add this domain',
  domainAlreadyClaimed:
    'This domain is already connected to another organization.',
  domainInvalid: 'Enter a valid corporate domain, for example company.com.',
  changeDomainWarning:
    'Changing the domain creates a new verification token and resets the current verification.',
  dnsCheckUnavailable: 'DNS check is temporarily unavailable',
  dnsCheckUnavailableDescription:
    'The verified status was not changed. Try the DNS check again in a few minutes.',
  domainRemoved: 'Domain removed',
  domainRemoveFailed: 'Could not remove the domain',
  removeDomain: 'Remove domain',
  removeDomainTitle: 'Remove organization domain?',
  removeDomainDescription:
    'Automatic approval by email domain will be disabled. Organization invitations will continue to work.',
  cancel: 'Cancel',

  // Invite link
  inviteLink: 'Invite Link',
  inviteLinkDescription:
    'Share this link to invite people to your organization. People without a matching verified domain require owner approval.',
  loadingInviteLink: 'Loading invite link...',
  failedToLoadInviteLink: 'Failed to load invite link.',

  // Members
  membersTitle: 'Members',
  nameColumn: 'Name',
  emailColumn: 'Email',
  roleColumn: 'Role',
  loadingMembers: 'Loading members...',
  failedToLoadMembers: 'Failed to load members.',
  noMembersFound: 'No members found.',
  loadingRequests: 'Loading requests...',
  failedToLoadRequests: 'Failed to load join requests.',
  noPendingRequests: 'No pending requests.',
  requested: 'Requested {{date}}',
  noEmail: 'No email',
  approve: 'Approve',
  reject: 'Reject',
  removeMemberTitle: 'Remove member',
  removeMemberConfirm:
    'Are you sure you want to remove {{name}} from the organization? All data about him will be deleted.',
  approveRequestTitle: 'Approve join request',
  rejectRequestTitle: 'Reject join request',
  requestActionConfirm:
    'Are you sure you want to {{action}} the request from {{name}}?',
  memberApproved: 'Member approved',
  requestRejected: 'Request rejected',
  failedToRemoveMember: 'Failed to remove member',
  failedToAction: 'Failed to {{action}} request',
  memberRemoved: 'Member removed',
  membersTab: 'Members',
  members: 'Members',
  joinRequestsTab: 'Join Requests',
  joinRequests: 'Join Requests',
  ownerBadge: 'owner',
  ownerRole: 'Owner',
  adminRole: 'Admin',
  memberRole: 'Member',
  memberRoleUpdated: 'Member role updated',
  failedToUpdateMemberRole: 'Failed to update member role',
  email: 'Email',
  role: 'Role',
  removeMember: 'Remove member',
  approveJoinRequest: 'Approve join request',
  rejectJoinRequest: 'Reject join request',
  joinRequestConfirm:
    'Are you sure you want to {{action}} the request from {{name}}?',
  failedToLoadJoinRequests: 'Failed to load join requests.',
  leaveOrganization: 'Leave organization',
  leaveOrganizationConfirm:
    'Are you sure you want to leave this organization? You will lose access to its workspaces.',
  leaveOrganizationSuccess: 'You left the organization',
  leaveOrganizationFailed: 'Failed to leave organization',

  // Onboarding
  loadingWorkspace: 'Loading workspace overview...',
  unableToLoadWorkspace: 'Unable to load your workspace overview',
  pleaseTryAgain: 'Please try again.',
  freePlanOnboarding: 'Free plan onboarding',
  createFirstWorkspace: 'Create your first workspace',
  createFirstWorkspaceDescription:
    'Set up your workspace to start collaborating with your team.',
  freePlanDescription:
    "You're using the free plan, which includes a lean setup for getting your first team workspace live.",
  maxWorkspaces: 'Max workspaces',
  maxSeats: 'Max seats',
  maxPlugins: 'Max plugins',
  maxMessagesPerWorkspaceMonth: 'Messages per workspace / month',
  historyRetention14Days: 'Chat history retention',
  historyRetentionDaysValue: '{{count}} days',
  workspaceLimitReachedNotification: 'Workspace limit reached',
  workspaceCreationUnavailableNotification: 'Workspace creation unavailable',
  askAdminForAccess:
    'Ask your organization owner or admin for workspace access.',
  noWorkspaceAccessTitle: 'No workspace access',
  noWorkspaceAccessDescription:
    "You're in {{name}}. Ask your admin to add you.",
  startWithOneWorkspace:
    'Start with one workspace now. You can upgrade later if your team outgrows the free plan.',

  // Org invites
  loadingInvite: 'Loading invite...',
  somethingWentWrong: 'Something went wrong',
  unableToLoadInvite: 'Unable to load invite details. Please try again later.',
  joinOrganization: 'Join {{name}}',
  signInOrCreateAccount:
    'Sign in or create an account to join this organization.',
  logIn: 'Log in',
  signUp: 'Sign up',
  invitedToJoin: 'You have been invited to join this organization.',
  failedToJoin: 'Failed to join. Please try again.',
  joinOrganizationButton: 'Join organization',
  joining: 'Joining...',
  welcomeTitle: 'Welcome!',
  joinedSuccessfully: 'You have successfully joined {{name}}. Redirecting...',
  requestSubmitted: 'Request submitted',
  requestSubmittedDescription:
    'Your request to join {{name}} has been submitted. An organization owner will review it shortly.',
  waitForApproval: 'You will get access once your request is approved.',
  goToWaitingPage: 'Go to waiting page',
  requestRejectedTitle: 'Request rejected',
  requestRejectedDescription:
    'Your request to join {{name}} was rejected. Please contact the organization administrator for more information.',
  goToHome: 'Go to home',
  previousRequestRejected:
    'Your previous request to join {{name}} was rejected. You can submit a new request.',
  applyAgain: 'Apply again',
  submitting: 'Submitting...',
  inviteNotFound: 'Invite not found',
  inviteInvalidOrExpired: 'This invite link is invalid or has expired.',
  unableToJoin: 'Unable to join',
  alreadyInOtherOrg:
    'You already belong to another organization. You must leave your current organization before joining a new one.',
  organizationFull: 'Organization is full',
  organizationFullDescription:
    'This organization has reached its maximum number of seats. Please contact the organization administrator.',

  // Workspace invites
  inviteLoadingWs: 'Loading invite...',
  inviteNotFoundWs: 'Invite not found',
  inviteInvalidOrExpiredWs: 'This invite link is invalid or has expired.',
  joinWorkspace: 'Join workspace',
  invitedToWorkspace: 'You have been invited to join {{name}}.',
  alreadyInWorkspace: 'You are already in this workspace.',
  joinedWorkspaceSuccessfully: 'You joined successfully.',
}
